var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataGuestsChart.labels)?_c('div',{staticStyle:{"width":"60%"}},[_c('GuestsChart',{attrs:{"data":_vm.dataGuestsChart,"options":_vm.optionsGuestsChart}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }